<button [ngClass]="'cb-button-'+type" [class.disabled]="disabled" [class.cb-large-icon-btn]="large" (click)="onClick($event)">
  <cb-icon [name]="icon"></cb-icon>
</button>
